export const GENDERS = ['female', 'male', 'non-binary', 'femboy'] as const;

export type Gender = (typeof GENDERS)[number];

export const isGender = (value: string): value is Gender =>
	GENDERS.includes(value as Gender);

export const getDisplayValue = (gender?: Gender | null) => {
	switch (gender) {
		case 'female':
			return 'Female';
		case 'male':
			return 'Male';
		case 'non-binary':
			return 'Transgender';
		case 'femboy':
			return 'Femboy';
		case null:
		case undefined:
			return 'All';
	}
};

export const TGENDERS = ['fem', 'mal', 'other', 'femboy'] as const;

export type TGender = (typeof TGENDERS)[number];

export const isTGender = (value: string): value is TGender =>
	TGENDERS.includes(value as TGender);

export const getTGenderValue = (
	gender?: Gender | null
): TGender | undefined => {
	switch (gender) {
		case 'female':
			return 'fem';
		case 'male':
			return 'mal';
		case 'non-binary':
			return 'other';
		case 'femboy':
			return 'femboy';
		case null:
		case undefined:
			return undefined;
	}
};

export const getGenderFromTGenderValue = (
	gender?: TGender | null
): Gender | undefined => {
	switch (gender) {
		case 'fem':
			return 'female';
		case 'mal':
			return 'male';
		case 'other':
			return 'non-binary';
		case 'femboy':
			return 'femboy';
		case null:
		case undefined:
			return undefined;
	}
};
